import React, { useEffect, useRef } from "react";
import { useState } from "react";
import {
  Button,
  Form,
  Row,
  Col,
  Dropdown,
  Overlay,
  Table,
  InputGroup,
} from "react-bootstrap";
import { Popover } from "react-tiny-popover";
import ReactDatePicker from "react-datepicker";
import Select from "react-select";
import {
  copyText,
  customerFullName,
  maxTopPopperConfig,
  pcsToTons,
  qtyFormat,
  reactSelectTheme,
  tonsToPcs,
  toTonsOrPcs,
  Units,
} from "./../utils/helpers";
import {
  AddCircleIcon,
  CreateInvoiceIcon,
  NoSelectedItemIcon,
  UserSolidIcon,
  CashSelectIcon,
  CreditSelectIcon,
  DirectTransferSelectIcon,
  ChequeSelectIcon,
  CustomerAccountSelectIcon,
  CreditMemoSelectIcon,
  EditIcon,
  DeleteIcon,
  RecieptIcon,
} from "./Icons";
import NewCustomerModal from "./NewCustomerModal";
import NewItemModal from "./NewItemModal";
import PageHeader from "./PageHeader";
import CurrencyCustomInput from "./utils/CurrencyCustomInput";
import ItemsTable from "./utils/ItemsTable";
import "./../assets/scss/create-invoice.scss";

import currency from "currency.js";
import DotsVeritcalIcon from "mdi-react/DotsVerticalIcon";
import { isEmpty, lowerCase } from "lodash";

import { useMemo } from "react";
import NumberCustomInput from "./utils/NumberCustomInput";
import { services } from "./../config";
import queryString from "query-string";
import { useQuery, useQueryClient } from "react-query";
import { queryActions, reportActions } from "./../utils/reactQueryActions";
import { useFormik } from "formik";
import * as yup from "yup";
import Datetime from "react-datetime";
import { useMutation } from "react-query";
import { toast } from "react-toastify";
import SelectBankDialog from "./SelectBankDialog";
import useDebounce, {
  useCurrencies,
  useEffectOnce,
  useIsAdmin,
  useIsHighLevelCashier,
  useUpdateEffect,
} from "./../utils/hooks";

import ConfirmDialog from "./ConfirmDialogue";

import { useAuth } from "./../hooks/useAuth";
import { useStoreActions, useStoreState } from "easy-peasy";
import ModalLoader from "./utils/ModalLoader";
import printJS from "print-js";
import CustomerSelectModal from "./CustomerSelectModal";
import DatePickerCustomInput from "./utils/DatePickerCustomInput";
import CreatableSelect from "react-select/creatable";
import ExpensesSelector from "./utils/ExpensesSelector";
import MagnifyIcon from "mdi-react/MagnifyIcon";
import DotsVerticalIcon from "mdi-react/DotsVerticalIcon";
import DotsHorizontalIcon from "mdi-react/DotsHorizontalIcon";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { first } from "lodash";
import { last } from "lodash";
import moment from "moment";
import eventBus from "../utils/EventBus";

const EditableRow = ({
  expense,
  handleRemove,
  index,
  edit,
  currencySymbol,
}) => {
  const [showExpensesPopover, setShowExpensesPopover] = useState(false);
  const initialValues = {
    AccountID: "",
    DetailType: "",
    Type: "",
    Description: "",
    Debit: 0,
    Credit: 0,
    Remark: "",
    bankData: {},
  };
  const formik = useFormik({
    initialValues,
    validationSchema: yup.object().shape({}),
    onSubmit: (values) => { },
  });

  const formValues = useDebounce(formik.values, 500);

  const setUp = () => {
    formik.setValues({
      AccountID: expense.AccountID,
      DetailType: expense.DetailType,
      Type: expense.Type,
      Description: expense.Description,
      Credit: expense.Credit,
      Debit: expense.Debit,
      Remark: expense?.Remark,
      bankData: expense?.bankData,
    });
  };

  useEffectOnce(() => {
    setUp();
  });

  useEffect(() => {
    for (let k in initialValues) {
      if (!formValues.hasOwnProperty(k)) {
        const key = String(k);
        formValues[key] = "";
      }
    }
    edit({
      index,
      formValues,
    });
  }, [formValues]);

  const handleSelectedExpense = (expense) => {
    formik.setValues({
      ...formik.values,
      AccountID: expense.AccountID,
      DetailType: expense.DetailType,
      Type: expense.Type,
      Description: expense.Description,
      //Remark: formik.values?.Remark,
    });
    setShowExpensesPopover(false);
  };

  return (
    <tr>
      <td>
        <Dropdown>
          <Dropdown.Toggle
            variant=""
            className="bg-white border-0"
            bsPrefix="print more"
          >
            <DotsVeritcalIcon />
          </Dropdown.Toggle>
          <Dropdown.Menu
            popperConfig={{
              strategy: "fixed",
            }}
            renderOnMount
            className="dropdown-with-icons"
          >
            <Dropdown.Item as="button" onClick={() => handleRemove(index)}>
              <DeleteIcon />
              Remove
            </Dropdown.Item>
          </Dropdown.Menu>{" "}
        </Dropdown>
      </td>
      <td>
        <InputGroup className="flex-nowrap">
          <Form.Control
            name="Account"
            value={`${expense.AccountID}/${expense.DetailType || ""}`}
            onChange={() => { }}
            readOnly
          />
          <Popover
            isOpen={showExpensesPopover}
            onClickOutside={() => setShowExpensesPopover(false)}
            content={() => (
              <ExpensesSelector
                handleSelectedExpense={handleSelectedExpense}
                usage={"chart of accounts"}
              />
            )}
            position="bottom"
          >
            <InputGroup.Text onClick={() => setShowExpensesPopover(true)}>
              <MagnifyIcon />
            </InputGroup.Text>
          </Popover>
        </InputGroup>
      </td>
      <td>
        <Form.Control
          name="AccountType"
          value={formik.values.Type}
          onChange={formik.handleChange}
          readOnly
        />
      </td>
      <td>
        <Form.Control
          name="Description"
          value={formik.values.Description}
          onChange={formik.handleChange}
        />
      </td>

      <td>
        <CurrencyCustomInput
          currencySymbol={currencySymbol}
          name="Debit"
          value={formik.values.Debit}
          onValueChange={(value, name) => {
            formik.setFieldValue(name, value);
          }}
        />
      </td>
      <td>
        <CurrencyCustomInput
          currencySymbol={currencySymbol}
          name="Credit"
          value={formik.values.Credit}
          onValueChange={(value, name) => {
            formik.setFieldValue(name, value);
          }}
        />
      </td>
      <td>
        <Form.Control
          name="Remark"
          value={formik.values.Remark}
          onChange={formik.handleChange}
          style={{ width: "25rem" }}
        />
      </td>
    </tr>
  );
};

export default function EditPendingCreateJournalEntry() {
  let { TransID } = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  const isAdmin = useIsAdmin();
  const isHighLevelCashier = useIsHighLevelCashier();
  const queryClient = useQueryClient();
  const { deploymentCurrencies: currenciesOptions } = useCurrencies();

  const defaultCustomer = useStoreState((state) => state.defaultCustomer);
  const { backendUrl } = useAuth();
  const [showExpensesPopover, setShowExpensesPopover] = useState(false);

  const [pendingActionID, setPendingActionID] = useState(null);
  const generalSettings = useStoreState((state) => state.generalSettings);
  const [tableData, setTableData] = useState([]);

  useEffectOnce(() => {
    if (location.state && location.state.journals) {
      setPendingActionID(location.state.id);
      setTableData(location.state.journals);
      if (location.state.currency === "USD") {
        formik.setFieldValue("currency", location.state.currency);
        formik.setFieldValue(
          "conversionAmount",
          location.state.conversionAmount
        );
      }
      navigate(location.pathname, { replace: true });
    }
  });

  const postJournalEntry = async (payload) => {
    const formData = new FormData();
    formData.append("payload", JSON.stringify(payload));

    let response = await fetch(`${backendUrl}/api/journal/journal-entry/create`, {
      method: "POST",
      credentials: "include",
      body: formData,
    });
    if (!response.ok) {
      response = await response.json();
      throw new Error(response.message);
    }
    const res = await response.json();
    return res;
  };

  const postJournalEntryMutation = useMutation(
    (payload) => postJournalEntry(payload),
    {
      onSuccess: ({ data, message }) => {
        toast.success(message);
        if (data?.approvalStatus === "Approved") {
          navigate(`/approval-action`);
        }
      },
      onError: ({ message = "" }) => {
        toast.error(`Unable to perform action: ${message}`);
      },
    }
  );

  const formik = useFormik({
    initialValues: {
      Reference: "",
      salesDate: moment(),
      conversionAmount: generalSettings.dollarInBaseCurrency,
      currency: generalSettings?.prevailingCurrency,
    },
    validationSchema: yup.object().shape({
      Reference: yup.string().required("required"),
    }),
    onSubmit: async (values) => {
      if (isEmpty(tableData)) return toast.error(`Please select`);

      // send to pending
      if (
        await ConfirmDialog({
          title: "Post Transaction",
          description: "Are you sure, you want to make this transaction",
        })
      ) {
        postJournalEntryMutation.mutate({
          journals: tableData.map((el) => ({ ...el, ...values, isApproved: true })),
          pendingActionID,
        });
      }
    },
    onReset: () => {
      setTableData([]);
    },
  });

  useEffectOnce(() => {
    formik.setFieldValue("Reference", TransID);
  });

  const fetchSetUpData = async (TransID) => {
    // await waitFor(5000);
    let response = await fetch(
      `${backendUrl}/api/journal/edit-entry/${TransID}`,
      {
        method: "GET",
        headers: {
          Accept: "Application/json",
          "Content-Type": "Application/json",
        },
        credentials: "include",
      }
    );

    if (!response.ok) {
      response = await response.json();
      throw new Error(response.message);
    }

    const { data } = await response.json();

    if (data?.journalEntry) {
      setTableData([
        ...data.journalEntry.map((el) => {
          //  get remark  from  ref
          // const remarkFromRef = el.Ref.split("-");
          return {
            AccountID: el.AccountDescription.AccountID,
            DetailType: el.AccountDescription.DetailType,
            Type: el.AccountID,
            Description: el.Description,
            Credit: el.Credit,
            Debit: el.Debit,
            // Remark: remarkFromRef[remarkFromRef.length - 1],
            Remark: el.Ref,
            bankData: el.bankData,
          };
        }),
      ]);

      formik.setFieldValue(
        "salesDate",
        new Date(data.journalEntry[0].DateLog),
        true
      );
    }
    return data;
  };

  const handleSelectedExpense = (expense) => {
    // balance Table
    if (!isEmpty(tableData)) {
      const lastItem = last(tableData);

      expense.Credit = Number(lastItem.Credit) > 0 ? 0 : lastItem.Debit;
      expense.Debit = Number(lastItem.Debit) > 0 ? 0 : lastItem.Credit;
    } else {
      expense.Credit = 0;
      expense.Debit = 0;
    }
    setTableData([...tableData, expense]);
    setShowExpensesPopover(false);
  };

  eventBus.useCustomEventListener("JOURNAL_ACCOUNT_CREATED", (account) => {
    handleSelectedExpense(account);
  });

  const edit = ({ index, formValues }) => {
    tableData[index] = {
      ...tableData[index],
      ...formValues,
    }; //clean  up

    setTableData([...tableData]);
  };

  const handleRemove = (index) => {
    setTableData([...tableData.filter((el, i) => i !== index)]);
  };

  const discard = () => {
    formik.resetForm();
    setTableData([]);
    formik.setFieldValue("Reference", TransID);
  };

  const updateAllPermit = async (payload) => {
    let response = await fetch(
      `${backendUrl}/api/permits/pending-action/change-status-all`,
      {
        method: "POST",
        credentials: "include",
        body: JSON.stringify(payload),
        headers: {
          Accept: "Application/json",
          "Content-Type": "Application/json",
        },
      }
    );
    if (!response.ok) {
      response = await response.json();
      throw new Error(response.message);
    }
    const { data } = await response.json();
    return data;
  };
  const updatePermitsMutation = useMutation(
    (payload) => updateAllPermit(payload),
    {
      onSuccess: ({ status, transactionIds }) => {
        toast.success(status);
      },
      onError: (err) => {
        toast.error(`Unable to perform action - ${err}`);
      },
    }
  );

  const approve = async () => {
    if (document.activeElement !== document.body) document.activeElement.blur();

    if (
      await ConfirmDialog({
        title: "Approve",
        description:
          "Are you sure, you want to approve,\n Transaction will be posted, Ensure you have saved changes",
      })
    ) {
      postJournalEntryMutation.mutate({
        journals: tableData.map((el) => ({ ...el, ...formik.values })),
        pendingActionID,
        approvalStatus: "Approved",
      });
    }
  };

  const disapprove = async (el) => {
    if (
      await ConfirmDialog({
        title: "Disapprove",
        description: "Are you sure, you want to disapprove",
      })
    ) {
      updatePermitsMutation.mutate({
        status: "Disapproved",
        transactionIds: [pendingActionID],
      });
    }
  };

  const currencySymbol = useMemo(() => {
    const foundCurrency = currenciesOptions.find(
      (el) => el.cc === formik.values.currency
    );
    return foundCurrency ? foundCurrency.symbol : "";
  }, [formik.values.currency]);

  return (
    <main className="create-invoice">
      <PageHeader
        name="Create Journal Entry"
        description="Approve"
        icon={<RecieptIcon />}
      />
      <div className="p-3 content">
        <div className="d-md-flex content-holder rounded">
          <section className="item-details">
            <div>
              <div className="actions">
                <div>
                  <h1 className="h4">#{TransID}</h1>
                </div>
                <div className="d-flex gap-3">
                  <Form.Group>
                    <Select
                      classNamePrefix="form-select"
                      placeholder="Select Currency"
                      isSearchable={true}
                      options={currenciesOptions}
                      value={currenciesOptions.find(
                        (el) => el.value === formik.values.currency
                      )}
                      onChange={({ value }) =>
                        formik.setFieldValue("currency", value)
                      }
                    />
                  </Form.Group>

                  {formik.values.currency &&
                    formik.values.currency !==
                    generalSettings?.prevailingCurrency ? (
                    <Form.Group>
                      <CurrencyCustomInput
                        currencySymbol={"Ex. Rate"}
                        name="conversionAmount"
                        value={formik.values.conversionAmount}
                        onValueChange={(value, name) => {
                          formik.setFieldValue(name, value);
                        }}
                        placeholder="0.00"
                      />
                    </Form.Group>
                  ) : null}
                </div>
              </div>

              <div className="selected-data-area  ">
                <div className="table-holder">
                  <Table
                    responsive
                    borderless
                    hover
                    striped
                    className="product-table  text-nowrap"
                  >
                    <thead>
                      <tr>
                        <th />
                        <th>GL/Accounts</th>
                        <th>Account Type</th>
                        <th>Description</th>
                        <th>Debit</th>
                        <th>Credit</th>
                        <th>Remark</th>
                      </tr>
                    </thead>
                    <tbody key={tableData?.length}>
                      {tableData.map((el, index) => (
                        <React.Fragment key={index}>
                          <EditableRow
                            index={index}
                            expense={el}
                            handleRemove={handleRemove}
                            edit={edit}
                            currencySymbol={currencySymbol}
                          />
                        </React.Fragment>
                      ))}
                      <tr style={{ backgroundColor: "#F7f7f7" }}>
                        <td colSpan={7}>
                          <Popover
                            isOpen={showExpensesPopover}
                            onClickOutside={() => setShowExpensesPopover(false)}
                            content={() => (
                              <ExpensesSelector
                                handleSelectedExpense={handleSelectedExpense}
                                usage={"chart of accounts"}
                                onHide={() => setShowExpensesPopover(false)}
                              />
                            )}
                            position="bottom"
                          >
                            <Button
                              variant="outline-primary"
                              className="px-3"
                              onClick={() => setShowExpensesPopover(true)}
                            >
                              + Add
                            </Button>
                          </Popover>
                        </td>
                      </tr>
                    </tbody>
                  </Table>
                </div>

                {isEmpty(tableData) ? (
                  <div className="no-item my-4">
                    <div className="info">
                      <NoSelectedItemIcon />
                      <h2 className="mb-2">Haven't selected an item yet</h2>
                      <p>You can click + Add to add an item to the table.</p>
                    </div>
                  </div>
                ) : null}
              </div>
            </div>

            {isAdmin || isHighLevelCashier ? (
              <div
                className="border-top py-4 d-flex mt-4 d-flex justify-content-start d-flex gap-3 	bg-white"
                style={{ zIndex: "10" }}
              >
                <Button
                  onClick={() => approve()}
                  className="px-4 py-2"
                  type="button"
                >
                  Approve
                </Button>

                <Button
                  onClick={() => disapprove()}
                  className="px-4 py-2"
                  variant="outline-danger"
                  type="button"
                >
                  Disapprove
                </Button>
              </div>
            ) : null}
          </section>
          <section className="customer">
            <Form noValidate onSubmit={formik.handleSubmit} autoComplete="off">
              <section className="date">
                <h2 className="mb-4">Payment Details</h2>

                <Form.Group className="form-mb align-items-center">
                  <Form.Label>Date</Form.Label>

                  <Datetime
                    timeFormat={false}
                    closeOnSelect={true}
                    closeOnClickOutside={true}
                    dateFormat="MMM DD, YYYY"
                    name="salesDate"
                    inputProps={{
                      className: `date-input form-control ${formik.touched.salesDate && !!formik.errors.salesDate
                        ? "is-invalid"
                        : ""
                        }`,
                      placeholder: "Select date",
                      readOnly: true,
                    }}
                    value={formik.values.salesDate}
                    onChange={(date) => {
                      formik.setFieldValue("salesDate", date, true);
                    }}
                    onBlur={() => formik.setFieldTouched("salesDate", true)}
                  />
                </Form.Group>
              </section>

              <Form.Group className="form-mb align-items-center">
                <Form.Label>Branch</Form.Label>
                <Select
                  classNamePrefix="form-select"
                  menuPlacement="top"
                  placeholder="HQ"
                  isSearchable={false}
                />
              </Form.Group>

              <Form.Group className="form-mb align-items-center">
                <Form.Label>Reference</Form.Label>
                <Form.Control
                  name="Reference"
                  value={formik.values.Reference}
                  onChange={formik.handleChange}
                  isInvalid={
                    formik.touched.Reference && !!formik.errors.Reference
                  }
                />
                <Form.Control.Feedback type="invalid">
                  {formik.errors.Reference}
                </Form.Control.Feedback>
              </Form.Group>

              {isAdmin || isHighLevelCashier ? (
                <section className="buttons">
                  <Button
                    type="button"
                    variant="outline-primary"
                    // className="border-0"
                    onClick={() => discard()}
                  >
                    Refresh
                  </Button>
                  <Button type="submit" variant="primary">
                    Save Changes
                  </Button>
                </section>
              ) : null}
            </Form>
          </section>
        </div>
      </div>
      <ModalLoader show={postJournalEntryMutation.isLoading} />
    </main>
  );
}
